import { ModalModule } from 'ngx-bootstrap/modal';

import { SystemCommonModule } from 'src/app/system-common/system-common.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HierarchyRoutingModule } from './hierarchy-routing.module';
import { LicenseDetailsSearchComponent } from './license-details-search/license-details-search.component';
import { MyTeamDetailsSearchComponent } from './my-team-details-search/my-team-details-search.component';
import { HierarchyService } from './services/hierarchy.service';
import { MyTeamDetailsComponent } from './my-team-details/my-team-details.component';
import { MyTeamDetailsTreeComponent } from './my-team-details-tree/my-team-details-tree.component';
import { TeamSchemeDetailsSearchComponent } from './team-scheme-details-search/team-scheme-details-search.component';
import { CountDetailsSearchComponent } from './count-details-search/count-details-search.component';

@NgModule({
  declarations: [
    LicenseDetailsSearchComponent,
    MyTeamDetailsSearchComponent,
    MyTeamDetailsComponent,
    MyTeamDetailsTreeComponent,
    TeamSchemeDetailsSearchComponent,
    CountDetailsSearchComponent,
  ],
  imports: [CommonModule, SystemCommonModule, HierarchyRoutingModule, ModalModule.forRoot()],
  exports: [MyTeamDetailsTreeComponent, TeamSchemeDetailsSearchComponent],
  providers: [HierarchyService],
})
export class HierarchyModule {}
